




























































import ExchangeCard from "@/shared/components/molecules/ExchangeCardMolecule.vue"
import InputAtom from "@/shared/components/atoms/InputAtom.vue"
import { computed, ComputedRef, defineComponent, WritableComputedRef } from "@vue/composition-api"
import { useActions, useGetters } from "vuex-composition-helpers"
import { InstitutionValue } from "@/apps/StudentExchangeNonPartnerWidget/models/institution-enums"

export default defineComponent({
    name: "ExchangeInstitution",
    components: { ExchangeCard, InputAtom },
    setup() {
        const {
            getLabels, 
            getInstitution,
            isEditable
        } = useGetters([
            'getLabels', 
            'getInstitution',
            'isEditable'
        ])
        const {
            setInstitution
        } = useActions([
            'setInstitution'
        ])

        const institution: WritableComputedRef<any> = computed({
            get(): any {
                return getInstitution.value
            },
            set(value: boolean): void {
                setInstitution(value)
            }
        })

        const countries = getLabels.value.countries.sort((a: any, b: any) => {
            if (a.name < b.name) {
                return -1
            }
            if (a.name > b.name) {
                return 1
            }
            return 0
        }).filter((country: any) => country.name != '')

        const disabled: ComputedRef<boolean> = computed(() => !isEditable.value)
        
        function handleInput(type: InstitutionValue, value: any) {
            switch (type) {
                case InstitutionValue.NAME:
                    institution.value = {
                        completed: false,
                        name: value,
                        city: institution.value.city,
                        country: institution.value.country
                    }
                    break
                case InstitutionValue.CITY:
                    institution.value = {
                        completed: false,
                        name: institution.value.name,
                        city: value,
                        country: institution.value.country
                    }
                    institution.value.city = value
                    break
                case InstitutionValue.COUNTRY:
                    institution.value = {
                        completed: false,
                        name: institution.value.name,
                        city: institution.value.city,
                        country: value
                    }
                    institution.value.country = value
                    break
            }
        }

        return {
            getLabels,
            countries,
            institution,
            disabled,
            InstitutionValue,
            handleInput
        }
    }
})
